import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-206039ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collecting" }
const _hoisted_2 = { class: "operationCont" }
const _hoisted_3 = { class: "UserManagement-table" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = { class: "paginationCont" }
const _hoisted_6 = { class: "dialog-footer" }

import { reactive, ref, onMounted, nextTick, onUnmounted, watch,onActivated } from "vue";
import { getDeptTree, getPage, bindPolicy, caseExport, backCollection,pushData, waterPic } from "../api";
import {
  FormInstance,
  FormRules,
  ElMessage,
  ElMessageBox,
  ElTable,
} from "element-plus";
import { Search, RefreshRight, Download } from "@element-plus/icons-vue";
import asyncDownTask from "@/views/compoents/asyncDownTask";
import { setField } from "@/utiles/utiles";
import { useRouter } from "vue-router";
interface ruleFormConfigItem {
  orderId: string;
  policyNo1: string;
  policyNo2: string;
  startDate1: string;
  startDate2: string;
  endDate1: string;
  endDate2: string;
}
interface ExportFormProps {
  taskName: string;
  range: string;
  mode: string;
}

/**
 * @typedef {Object} ExportForm 导出form
 * @property {string} taskName - 任务名称
 * @property {string} range - 导出范围
 * @property {string} mode - 处理方式
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'auditedPage',
  setup(__props) {

const pageSizes = ref([10, 20, 50]);
const hasInitialSearch = ref(false);

const userManuallySetPageSize = ref(false);
const calculateTableRows = () => {
  // 如果用户手动设置了页面大小，则不进行自动计算
  if (userManuallySetPageSize.value) {
    return;
  }
  const tableContainer = document.querySelector('.UserManagement-table');
  if (!tableContainer) {
    console.log('未找到表格容器');
    return;
  }

  const allRows = document.querySelectorAll('.el-table__row');
  if (!allRows.length) {
    if (!hasInitialSearch.value) {
      hasInitialSearch.value = true;
      onSearch(false);
    }
    return;
  }

  // 计算新的 pageSize
  const totalHeight = Array.from(allRows).reduce((sum, row) => {
    return sum + row.getBoundingClientRect().height;
  }, 0);
  const rowHeight = totalHeight / allRows.length;
  const containerHeight = tableContainer.clientHeight;
  const tableHeader = document.querySelector('.el-table__header');
  const headerHeight = tableHeader ? tableHeader.getBoundingClientRect().height : 0;
  const availableHeight = containerHeight - headerHeight;
  const maxRows = Math.floor(availableHeight / rowHeight);
  const calculatedSize = Math.ceil(maxRows / 5) * 5;

  if (queryForm.pageSize === calculatedSize) {
    return;  // 如果分页大小没变，直接返回
  }

  // 更新分页相关配置
  pageSizes.value = [calculatedSize, calculatedSize * 2, calculatedSize * 3];
  defaultPageSize.value = calculatedSize;
  queryForm.pageSize = calculatedSize;
  onSearch(true);
};
const defaultPageSize = ref(10);
let queryForm = reactive({
  condition: {
    deptId: "",
    farmerName: "",
    status: "CHECKED",
    policyNo: "",
    orderDate: new Date().getFullYear() + "",
    caseNo: "",
  },
  pageIndex: 1,
  pageSize: defaultPageSize.value,
});

const ruleForm = reactive<ruleFormConfigItem>({
  orderId: "",
  policyNo1: "",
  policyNo2: "",
  startDate1: "",
  startDate2: "",
  endDate1: "",
  endDate2: "",
});
const rules = reactive<FormRules>({
  policyNo1: [
    {
      pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{2,22}$/,
      message: "请输入22位数字加字母",
      trigger: "blur",
    },
  ],
  policyNo2: [
    {
      pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{2,22}$/,
      message: "请输入22位数字加字母",
      trigger: "blur",
    },
  ],
});

// 定义导出form
const exportForm = reactive<ExportFormProps>({
  taskName: "",
  range: "",
  mode: "",
});
onActivated(() => {
  console.log("进入了已审核页面2");
  onSearch(true);
});

const exportFormRules = reactive<FormRules>({
  taskName: [
    {
      required: true,
      pattern: /[\u4e00-\u9fa50-9A-Za-z]+/,
      message: "请输入正确的任务名称",
      trigger: "blur",
    },
  ],
  range: [
    {
      required: true,
      message: "请选择导出范围",
      trigger: "blur",
    },
  ],
  mode: [
    {
      required: true,
      message: "请选择处理方式",
      trigger: "blur",
    },
  ],
});

const Router = useRouter();
const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const formSize = ref("default");
const deptTree = ref<any>([]);
const total = ref<number>(0);
const tableData = ref<any>([]);
const queryFormRef = ref<FormInstance>();
const ruleFormRef = ref<FormInstance>();
const policyNo1Time = ref([]);
const policyNo2Time = ref([]);
const selectIds = ref<any>([]);
const dialogInsureVisible = ref(false);
const dialogDownTaskVisible = ref(false);

const exportDialogVisible = ref(false);
const exportFormRef = ref<FormInstance>();

onMounted(() => {
  nextTick(() => {
    calculateTableRows();
  });
  getDeptTreeFn();
  let queryPage = sessionStorage.getItem("claimQuery")
    ? JSON.parse(sessionStorage.getItem("claimQuery") || "").audited
    : {};
  queryForm = reactive({
    ...queryForm,
    ...queryPage,
  });
  // onSearch(true);
  const debouncedCalculate = debounce(calculateTableRows, 200);
  window.addEventListener('resize', debouncedCalculate);
});
watch(tableData, () => {
    if (tableData.value.length > 0) {  // 只在有数据时才重新计算
        nextTick(() => {
            calculateTableRows();
        });
    }
}, { immediate: false });
onUnmounted(() => {
    window.removeEventListener('resize', calculateTableRows);
    userManuallySetPageSize.value = false;
});
const debounce = (fn: Function, delay: number) => {
    let timer: any = null;
    return function (this: any, ...args: any[]) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            userManuallySetPageSize.value = false;
            fn.apply(this, args);
        }, delay);
    };
};
const getDeptTreeFn = () => {
  getDeptTree().then((res: any) => {
    deptTree.value = res;
  });
};
const handleDTaskClose = (formEl: any, type: boolean) => {
  if (!formEl) return;
  formEl.resetFields();
  if (type) {
    dialogDownTaskVisible.value = false;
  }
};
const downTaskVisible = () => {
  dialogDownTaskVisible.value = true;
};

const handleSelectionChange = (val: any[]) => {
  selectIds.value = val.map((v) => v.id);
};
const policyNo1Change = (tims: any[]) => {
  [ruleForm.startDate1, ruleForm.endDate1] = tims;
};
const policyNo2Change = (tims: any[]) => {
  [ruleForm.startDate2, ruleForm.endDate2] = tims;
};
const onSearch = (type: boolean) => {
  if (type) {
    queryForm.pageIndex = 1;
  }
  sessionStorage.setItem("claimQuery", JSON.stringify({ audited: queryForm }));

  getPage(queryForm).then((res: any) => {
    const { items, totalSize } = res;
    total.value = Number(totalSize);
    tableData.value = items;
  });
};

const waterPics = () => {
  console.log("waterPics");
  console.log("selectIds.value",selectIds.value);
  if (selectIds.value.length == 0) {
    ElMessage({
      type: "warning",
      message: "请选择案件数据",
    });
    return;
  }

  waterPic({ ids: selectIds.value }).then(() => {
    ElMessage.success("处理成功");
  })
      .finally(() => {
        onSearch(true);
      })
};
const resetForm = (formEl: FormInstance | undefined, type: boolean) => {
  if (!formEl) return;
  formEl.resetFields();
  queryForm.condition.orderDate = "";
  if (type) {
    dialogInsureVisible.value = false;
  }
  sessionStorage.setItem("claimQuery", JSON.stringify({ audited: queryForm }));
};
const formatPolicyType = (row: any) => {
  switch (row.policyType) {
    case 'INDIVIDUAL':
      return '个体';
    case 'GROUP':
      return '团体';
    default:
      return row.policyType;
  }
};
const formatPushStatus = (row: any) => { 
  const result = String(row.pushResult || '');
  
  switch (result) {
    case "HANDLE_DATA":
      return "数据处理中";
    case "EXCEPTION_DATA":
      return "数据处理异常";
    case "SUCCESS_DATA":
      return "数据处理完成";
    case "HANDLE_PUSH":
      return "推送中";
    case "SUCCESS_PUSH":
      return "推送成功";
    case "EXCEPTION_PUSH":
      return "推送异常";
    case "WAIT_PUSH":
      return "待推送";
    default:
      return result;
  }
};
const formatStatus = (row: any) => {
  switch (row.status) {
    case 'CANCELLED':
      return '注销';
    case 'COMPLETED':
      return '已完成';
    default:
      return '';
  }
};
const watermarkStatus = (row: any) => {
  switch (row.watermarkStatus) {
    case 'INIT':
      return '还未处理';
    case 'HANDLE':
      return '生成中';
    case 'EXCEPTION':
      return '生成异常';
    case 'SUCCESS':
      return '生成成功';
    default:
      return '';
  }
};
// 关联保单
const association = (row: any) => {
  dialogInsureVisible.value = true;
  ruleForm.orderId = row.id;
  for (let key in row) {
    const k = key as keyof ruleForm;
    if (row[k]) setField(ruleForm, k, row[k]);
  }
  policyNo1Time.value = [row.startDate1, row.endDate1];
  policyNo2Time.value = [row.startDate2, row.endDate2];
};
// 提交关联保单
const submitForm = async (formEl: FormInstance) => {
  if (!formEl) return;
  if (ruleForm.policyNo1 && !ruleForm.startDate1) {
    ElMessage({
      type: "error",
      message: "请选择商业保单起止期",
    });
    return;
  }
  if (ruleForm.policyNo2 && !ruleForm.startDate2) {
    ElMessage({
      type: "error",
      message: "请选择商业保单起止期",
    });
    return;
  }
  await formEl.validate((valid: any, fields: any) => {
    if (valid) {
      bindPolicy(ruleForm).then((res: any) => {
        ElMessage({
          type: "success",
          message: "保单号关联成功",
        });
        onSearch(true);
        resetForm(ruleFormRef, true);
      });
    } else {
    }
  });
};
const handleClose = (formEl: any, type: Boolean) => {
  if (!formEl) return;
  formEl.resetFields();
  if (type) {
    dialogInsureVisible.value = false;
  }
  ruleForm.orderId = "";
  policyNo2Time.value = [];
  policyNo1Time.value = [];
};
const viewDetail = (row: any) => {
  sessionStorage.setItem('claimTargetData',JSON.stringify({
      id: row.id,
      name: "audited",
    }))
  Router.push({
    name: "claimTargetData",
    query: {
      id: row.id,
      name: "audited",
    },
  });
};
// 退回采集
const returnCollection = (row: any) => {
    const params = { caseId:row.id, status:'CHECKED', type:'VALIDATE' }
    backCollection(params).then(() =>{
      ElMessage.success('退回采集成功')
      resetForm(queryFormRef.value, false)
      onSearch(true)

    }).catch(()=>{})
}

//推送数据
const pushCaseData = (row: any) => {
  pushData(row.id)
    .then(() => {
      ElMessage.success("推送数据成功");
    })
    .catch((error: any) => {
    //   console.log(error?.[0]?.message);
      
    //   ElMessage.error(error?.[0]?.message || "推送数据失败");
    })
      .finally(() => {
        onSearch(true);
      })
};
const handleSizeChange = (val: number) => {
  userManuallySetPageSize.value = true; // 设置标志位表示用户手动修改了页面大小
  queryForm.pageSize = val;
  onSearch(true);
};
const handleCurrentChange = (val: number) => {
  queryForm.pageIndex = val;
  onSearch(false);
};

const formatTimestamp = () => {
  const now = new Date();
  const pad = (num: number, size = 2) => String(num).padStart(size, '0');
  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());
  const centiseconds = pad(Math.floor(now.getMilliseconds() / 10));
  return `${hours}${minutes}${seconds}${centiseconds}`;
};

// 导出
const claimCaseExport = () => {
  if (selectIds.value.length == 0) {
    ElMessage({
      type: "warning",
      message: "请选择需要导出的案件数据",
    });
    return;
  }
  const selectedRows = multipleTableRef.value!.getSelectionRows();
  // 养殖户姓名并用、连接+的理赔案件影像
  const farmerNames = selectedRows.map(row => row.farmerName).join('、') + '的理赔案件影像';
  exportForm.taskName = `${farmerNames}${formatTimestamp()}`;

  exportDialogVisible.value = true;
};

// 导出确认框关闭事件
const handleCancel = () => {
  if (exportFormRef.value) {
    exportFormRef.value.resetFields();
  }
  exportDialogVisible.value = false;
};
// 导出确认框确认事件
const handleConfirm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      const { mode, range, taskName } = exportForm
      caseExport(
        {
          request: { ids: selectIds.value, mode, range },
          taskName,
          exportType: "CLAIM_EXPORT",
        },
        `理赔信息${new Date()
          .toISOString()
          .substr(0, 10)} ${new Date().toLocaleTimeString()}.zip`
      ).then(() => {
        exportDialogVisible.value = false;
        ElMessage({
          type: "success",
          message: "创建下载任务成功",
        });
        multipleTableRef.value!.clearSelection();
      });

    } else {
      console.log("error submit!");
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: true,
        model: _unref(queryForm),
        class: "demo-form-inline",
        ref_key: "queryFormRef",
        ref: queryFormRef
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "归属机构",
            prop: "condition.deptId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tree_select, {
                placeholder: "归属机构",
                "check-strictly": "",
                clearable: "",
                modelValue: _unref(queryForm).condition.deptId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(queryForm).condition.deptId) = $event)),
                data: deptTree.value,
                "render-after-expand": false,
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue", "data"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "养殖户姓名",
            prop: "condition.farmerName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(queryForm).condition.farmerName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(queryForm).condition.farmerName) = $event)),
                modelModifiers: { trim: true },
                clearable: "",
                placeholder: "养殖户姓名",
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "案件号",
            prop: "condition.caseNo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(queryForm).condition.caseNo,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(queryForm).condition.caseNo) = $event)),
                modelModifiers: { trim: true },
                clearable: "",
                placeholder: "案件号",
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "年度",
            prop: "condition.orderDate"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _unref(queryForm).condition.orderDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(queryForm).condition.orderDate) = $event)),
                format: "YYYY",
                "value-format": "YYYY",
                type: "year",
                placeholder: "年度",
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "保单号",
            prop: "condition.policyNo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(queryForm).condition.policyNo,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(queryForm).condition.policyNo) = $event)),
                modelModifiers: { trim: true },
                clearable: "",
                placeholder: "保单号",
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _unref(Search),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (onSearch(true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查 询")
                ]),
                _: 1
              }, 8, ["icon"]),
              _createVNode(_component_el_button, {
                plain: "",
                icon: _unref(RefreshRight),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (resetForm(queryFormRef.value, false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重 置")
                ]),
                _: 1
              }, 8, ["icon"]),
              _createVNode(_component_el_button, {
                icon: _unref(Download),
                onClick: claimCaseExport
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新建下载任务")
                ]),
                _: 1
              }, 8, ["icon"]),
              _createVNode(_component_el_button, {
                icon: _unref(Download),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (downTaskVisible()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载任务列表")
                ]),
                _: 1
              }, 8, ["icon"]),
              _createVNode(_component_el_button, { onClick: waterPics }, {
                default: _withCtx(() => [
                  _createTextVNode("重新生成水印照片")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(ElTable), {
        ref_key: "multipleTableRef",
        ref: multipleTableRef,
        onSelectionChange: handleSelectionChange,
        data: tableData.value,
        border: "",
        style: {"width":"100%"},
        height: "100%",
        onRowMounted: calculateTableRows
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }),
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            width: "60",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "deptName",
            label: "归属机构",
            width: "100",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "farmerName",
            label: "养殖户姓名",
            width: "100",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "idCard",
            label: "证件号码",
            width: "100",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "caseNo",
            label: "案件号",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "targetNum",
            label: "理赔数量",
            width: "100",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "normalNum",
            label: "唯一理赔数量",
            width: "110",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "repeatNum",
            label: "重复理赔数量",
            width: "110",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "policyType",
            label: "保单类型",
            width: "110",
            align: "center",
            formatter: formatPolicyType
          }),
          _createVNode(_component_el_table_column, {
            prop: "policyNo1",
            label: "政策投保单号",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "policyNo2",
            label: "商业投保单号",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "userName",
            label: "查勘人",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "created",
            label: "创建时间",
            width: "100",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "submitTime",
            label: "完成时间",
            width: "100",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "pushResult",
            label: "推送状态",
            width: "110",
            align: "center",
            formatter: formatPushStatus
          }),
          _createVNode(_component_el_table_column, {
            prop: "status",
            label: "同步状态",
            width: "100",
            align: "center",
            formatter: formatStatus
          }),
          _createVNode(_component_el_table_column, {
            prop: "watermarkStatus",
            label: "水印生成状态",
            width: "110",
            align: "center",
            formatter: watermarkStatus
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "180",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (viewDetail(scope.row)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 查看详情 ")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (pushCaseData(scope.row)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 数据推送 ")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (returnCollection(scope.row)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 退回采集 ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_el_dialog, {
      draggable: "",
      modelValue: dialogInsureVisible.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((dialogInsureVisible).value = $event)),
      title: "保单号关联",
      width: "500px",
      onClose: _cache[15] || (_cache[15] = ($event: any) => (handleClose(ruleFormRef.value, true))),
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (resetForm(ruleFormRef.value, true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取 消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (submitForm(ruleFormRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确 定 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: ruleForm,
          rules: rules,
          "label-width": "80px",
          class: "demo-ruleForm",
          size: formSize.value,
          "status-icon": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "政策投保单号",
              prop: "policyNo1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.policyNo1,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((ruleForm.policyNo1) = $event)),
                  maxlength: "22",
                  placeholder: "政策投保单号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "保单期限" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: policyNo1Time.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((policyNo1Time).value = $event)),
                  onChange: policyNo1Change,
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "政策保单起期",
                  "end-placeholder": "政策保单止期",
                  format: "YYYY/MM/DD",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "商业投保单号",
              prop: "policyNo2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.policyNo2,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ruleForm.policyNo2) = $event)),
                  maxlength: "22",
                  placeholder: "商业投保单号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "保单期限" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: policyNo2Time.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((policyNo2Time).value = $event)),
                  onChange: policyNo2Change,
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "商业保单起期",
                  "end-placeholder": "商业保单止期",
                  format: "YYYY/MM/DD",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "size"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      draggable: "",
      modelValue: dialogDownTaskVisible.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((dialogDownTaskVisible).value = $event)),
      center: "",
      title: "下载任务列表",
      width: "50%",
      onClose: _cache[17] || (_cache[17] = ($event: any) => (handleDTaskClose(ruleFormRef.value, true))),
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        (dialogDownTaskVisible.value)
          ? (_openBlock(), _createBlock(_unref(asyncDownTask), {
              key: 0,
              exportType: "CLAIM_EXPORT"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "total, sizes, prev, pager, next",
        "page-sizes": pageSizes.value,
        total: total.value,
        "current-page": _unref(queryForm).pageIndex,
        "onUpdate:current-page": _cache[18] || (_cache[18] = ($event: any) => ((_unref(queryForm).pageIndex) = $event)),
        "page-size": _unref(queryForm).pageSize,
        "onUpdate:page-size": _cache[19] || (_cache[19] = ($event: any) => ((_unref(queryForm).pageSize) = $event)),
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: exportDialogVisible.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((exportDialogVisible).value = $event)),
      title: "提示",
      width: "500",
      "before-close": handleCancel,
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, { onClick: handleCancel }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (handleConfirm(exportFormRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "exportFormRef",
          ref: exportFormRef,
          model: exportForm,
          rules: exportFormRules,
          "label-position": "top",
          class: "export-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "任务名称",
              "label-width": "auto",
              prop: "taskName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: exportForm.taskName,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((exportForm.taskName) = $event)),
                  modelModifiers: { trim: true },
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "导出范围",
              "label-width": "auto",
              prop: "range"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: exportForm.range,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((exportForm.range) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: "NORMAL",
                      label: "NORMAL"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("唯一标的")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      value: "REPEAT",
                      label: "REPEAT"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重复标的")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      value: "ALL",
                      label: "ALL"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("全部标的")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "处理方式",
              "label-width": "auto",
              prop: "mode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: exportForm.mode,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((exportForm.mode) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: "ALL",
                      label: "ALL"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("所有采集的部位全部导出，含正脸、左侧脸、右侧脸、鼻纹")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      value: "OPTIMAL",
                      label: "OPTIMAL"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("所有采集的部位导出最优一张，含正脸、左侧脸、右侧脸、鼻纹")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      value: "MERGE",
                      label: "MERGE"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("按标的合并所有采集部位为一张图片")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})